import { useEffect, useState } from "react";
import { setRangeFilter } from "../services/data-service";
import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';
import "./filters-range-input.scss";

const FilterRangeInput = ({group}) => {

    const createSliderWithTooltip = Slider.createSliderWithTooltip;
    const Range = createSliderWithTooltip(Slider.Range);

    const minValue = parseInt(group.data[0]);
    const maxValue = parseInt(group.data[group.data.length -1]);

    const [marks, setMarks] = useState({[minValue]: minValue, [maxValue]: maxValue});
    const [currentRange, setCurrentRange] = useState([group.currentRange[0], group.currentRange[1]]);

    const onChange = (data) => {
        setCurrentRange(data);
        setRangeFilter(data);
    }

    useEffect(() => {
        setMarks({
            [minValue]: minValue, 
            [currentRange[0]]: currentRange[0],
            [currentRange[1]]: currentRange[1],
            [maxValue]: maxValue
        });        
    }, [currentRange, minValue, maxValue]);

    return(
        <div className="range-slider-container">
            <Range
                min={minValue}
                max={maxValue}
                defaultValue={currentRange}
                onAfterChange={onChange}
                marks={marks}
            />
        </div>
    );
}

export default FilterRangeInput;